import { CHAT_GROUP_TYPE } from '../global/constants';
import { ChatGroupInterface, UserInterface } from '../interfaces/chatMessageInterface';
import { ProjectModel } from '../mobx/models/project';

// The synthetic "Everyone" entry shown at the top of the mention list to notify all group members.
export const EVERYONE_MENTION_USER = {
  id: 'everyone',
  name: 'Everyone',
  profile_photo: '',
  value: 'everyone',
  email: 'everyone'
};

/**
 * Build the mention list with the "Everyone" option prepended, excluding the current user.
 * Shared by the message send box and the message edit modal so both stay in sync.
 */
export const getMentionUsersWithEveryone = (users: UserInterface[], currentUserId?: string): UserInterface[] => [
  EVERYONE_MENTION_USER,
  ...(users?.filter((user) => user?.id !== currentUserId) || [])
];

/**
 * Whether the "Everyone" mention should be offered for the given conversation.
 * Project messages always allow it; navbar messages allow it unless it's a 1-on-1 personal chat.
 */
export const getIsEveryoneMentionEnable = (
  currentProject: ProjectModel | ChatGroupInterface | null,
  isNavbarMessage: boolean
): boolean =>
  isNavbarMessage
    ? (currentProject as ChatGroupInterface)?.type !== CHAT_GROUP_TYPE.PERSONAL ||
      !!(currentProject?.users && currentProject?.users?.length > 2)
    : true;
